<p-toast></p-toast>

<div>
    <button (click)="memberFieldDialogVisibility=!memberFieldDialogVisibility" pButton type="button"
    [label]='setLabel("createFieldLabel")' icon="pi pi-save" class="ui-button-info"></button>
</div>
<div class="card">
    <h5>{{setLabel("memberFormFieldsLabel")}}</h5>
    <p-table [value]="products2" dataKey="id" editMode="row">
        <ng-template pTemplate="header">
            <tr>
                <th>{{setLabel("codeLabel")}}</th>
                <th>{{setLabel("nameLabel")}}</th>
                <th>{{setLabel("categoryLabel")}}</th>
                <th>{{setLabel("quantityLabel")}}</th>
                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="product">
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="product.code">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{product.code}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="product.name" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{product.name}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-dropdown [options]="statuses" [(ngModel)]="product.inventoryStatus"
                                [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{product.inventoryStatus}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="product.price">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{product.price | currency: 'USD'}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td style="text-align:center">
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                        (click)="onRowEditInit(product)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                        (click)="onRowEditSave(product)"
                        class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                        (click)="onRowEditCancel(product, ri)"
                        class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog [header]='setLabel("payFundHeaderLabel")' [(visible)]="memberFieldDialogVisibility" [closeOnEscape]="true">
    <form #memberFormFields="ngForm" style="height: 250px; width: 570px;">
        <div class="ui-g-12 ui-md-12">
            <div class="ui-g-6 ui-md-3">
                <h4>{{setLabel("fieldNameLabel")}}<span style="color:red;">*</span></h4>
            </div>
            <div class="ui-g-6 ui-md-6">
                <div class="ui-inputgroup">
                    <span class="ui-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                    <input autocomplete="off" pattern="[A-Za-z ]+" [ngClass]="fieldName.invalid
                        &&
                        (fieldName.dirty ||
                        fieldName.touched)
                        ? 'errorInput'
                        : ''" type="text" autofocus id="fieldName" pInputText [placeholder]='setLabel("name*PlaceholderLabel")' #fieldName="ngModel"
                        name="name" required [(ngModel)]="memberFormField.field" />
                </div>
                <div *ngIf="fieldName.invalid &&
                    (fieldName.dirty ||
                    fieldName.touched)">
                    <div *ngIf="fieldName.errors.required" class="errorShow">
                        {{setLabel("fieldNameRequiredLabel")}}
                    </div>
                    <div *ngIf="fieldName.errors.pattern" class="errorShow">
                        {{setLabel("charactersAllowedLabel")}}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="ui-g-12 ui-md-12"> -->
        <!-- <div class="ui-inputgroup">
          <span class="ui-inputgroup-addon">PKR </span>
          <input type="number" style="width: 100% !important;" required pattern="[0-9]+" autocomplete="off" pInputText
            placeholder="Price" name="feePay" [(ngModel)]="fund.pay" #feePay="ngModel"
            [ngClass]="feePay.invalid && (feePay.dirty || feePay.touched) ? 'errorInput' : '' ">
          <span class="ui-inputgroup-addon">.00</span>
        </div>
        <div *ngIf="feePay.invalid && (feePay.dirty || feePay.touched)">
          <div *ngIf="feePay.errors.required" class="errorShow">
            Please Enter Fee Correctly.
          </div>
          <div *ngIf="feePay.errors.pattern" class="errorShow">
            Please Enter Fee Correctly.
          </div>
        </div>
      </div> -->
        <p-footer>
            <button (click)="createFormField()" [disabled]="!memberFormFields.valid" pButton type="button"
            [label]='setLabel("createLabel")' icon="pi pi-save" class="ui-button-success"></button>
        </p-footer>
    </form>
</p-dialog>